import app from "/src/app/app.module";

app.config(['$translateProvider', function ($translateProvider) {

    $translateProvider.translations('nl-nl', {
        FORM_SCHEMAS: 'Formuliersjablonen',
        FORM_BUILDER: 'Formulier Bouwer',
        FORM_NAME: 'Formuliernaam',
        NEW_FORM: 'Nieuw Formulier',
        SAVE_FORM: 'Formulier Opslaan',
        EXPORT: 'Exporteren',
        SHOW_SCHEMA: 'Gegenereerd Schema Tonen',
        COLLAPSE: 'Samenvouwen',
        GENERATED_SCHEMA: 'Gegenereerd Formulier Schema',
        COPY: 'Kopiëren',
        FIELD_TYPES: 'Veldtypen',
        ADD_ROW: 'Rij Toevoegen',
        CANVAS: 'Canvas',
        DRAG_FIELDS: 'Sleep velden van links of klik om toe te voegen',
        FORM_PREVIEW: 'Formuliervoorbeeld',
        ADD_FIELDS_PREVIEW: 'Voeg velden toe om het voorbeeld hier te zien',
        FIELD_CONFIGURATION: 'Veldconfiguratie',
        ROW_CONFIGURATION: 'Rijconfiguratie',
        PROPERTY_NAME: 'Eigenschapsnaam',
        LABEL: 'Label',
        TYPE: 'Type',
        PLACEHOLDER: 'Plaatshoudertekst',
        HELP_TEXT: 'Hulptekst',
        COLUMN_WIDTH: 'Kolombreedte',
        REQUIRED_FIELD: 'Verplicht veld',
        MIN_LENGTH: 'Minimale lengte',
        MAX_LENGTH: 'Maximale lengte',
        NUMBER_OF_COLUMNS: 'Aantal kolommen',
        ADD_FIELD_TO_ROW: 'Veld aan Rij Toevoegen',
        NO_SAVED_FORMS: 'Geen opgeslagen formulieren. Maak er een nieuw aan om te beginnen!',
        DELETE_FORM: 'Formulier verwijderen',
        FORM_SAVED: 'Formulier succesvol opgeslagen',
        SCHEMA_COPIED: 'Schema naar klembord gekopieerd',
        SCHEMA_EXPORTED: 'Schema naar console geëxporteerd',
        FULL: 'Vol (12)',
        HALF: 'Halfte (6)',
        THIRD: 'Derde (4)',
        QUARTER: 'Kwart (3)',
        SMALL: 'Klein (2)',
        TEXT_INPUT: 'Tekstinvoer',
        EMAIL: 'E-mail',
        NUMBER: 'Getal',
        PASSWORD: 'Wachtwoord',
        TEXTAREA: 'Tekstgebied',
        CHECKBOX: 'Selectievakje',
        DATE: 'Datum',
        SELECT: 'Selecteren',
        ROW: 'Rij',
        OPTIONS: 'Opties',
        ADD_OPTION: 'Optie Toevoegen',
        DEFAULT_CHECKED: 'Standaard Aangevinkt',
        CHECKED_BY_DEFAULT: 'Standaard aangevinkt'
    });

    const translations = {
        FORM_SCHEMAS: 'Form Schemas',
        FORM_BUILDER: 'Form Builder',
        FORM_NAME: 'Form Name',
        NEW_FORM: 'New Form',
        SAVE_FORM: 'Save Form',
        EXPORT: 'Export',
        SHOW_SCHEMA: 'Show Generated Schema',
        COLLAPSE: 'Collapse',
        GENERATED_SCHEMA: 'Generated Form Schema',
        COPY: 'Copy',
        FIELD_TYPES: 'Field Types',
        ADD_ROW: 'Add Row',
        CANVAS: 'Canvas',
        DRAG_FIELDS: 'Drag or click fields from the left to add them',
        FORM_PREVIEW: 'Form Preview',
        ADD_FIELDS_PREVIEW: 'Add fields to see the preview here',
        FIELD_CONFIGURATION: 'Field Configuration',
        ROW_CONFIGURATION: 'Row Configuration',
        PROPERTY_NAME: 'Property Name',
        LABEL: 'Label',
        TYPE: 'Type',
        PLACEHOLDER: 'Placeholder',
        HELP_TEXT: 'Help Text',
        COLUMN_WIDTH: 'Column Width',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH: 'Min Length',
        MAX_LENGTH: 'Max Length',
        NUMBER_OF_COLUMNS: 'Number of Columns',
        ADD_FIELD_TO_ROW: 'Add Field to Row',
        NO_SAVED_FORMS: 'No saved forms yet. Create a new one to get started!',
        DELETE_FORM: 'Delete form',
        FORM_SAVED: 'Form saved successfully',
        SCHEMA_COPIED: 'Schema copied to clipboard',
        SCHEMA_EXPORTED: 'Schema exported to console',
        FULL: 'Full (12)',
        HALF: 'Half (6)',
        THIRD: 'Third (4)',
        QUARTER: 'Quarter (3)',
        SMALL: 'Small (2)',
        TEXT_INPUT: 'Text Input',
        EMAIL: 'Email',
        NUMBER: 'Number',
        PASSWORD: 'Password',
        TEXTAREA: 'Textarea',
        CHECKBOX: 'Checkbox',
        DATE: 'Date',
        SELECT: 'Select',
        ROW: 'Row',
        OPTIONS: 'Options',
        ADD_OPTION: 'Add Option',
        DEFAULT_CHECKED: 'Default Checked',
        CHECKED_BY_DEFAULT: 'Checked by default'
    };

    $translateProvider.translations('en-gb', translations);
    $translateProvider.translations('en-us', translations);

    $translateProvider.preferredLanguage('nl-nl');
}]);
